import { Injectable } from '@angular/core';
import { ClientAppConfig, DCarbonizeAppConfig } from './@types/shared/app-config';
import { InjectionToken } from '@angular/core';
import { environment } from 'environments/environment';

export const DCAR_APP_CONFIG = new InjectionToken<DCarbonizeAppConfig>('DCAR_APP_CONFIG');

export interface IConfigService {
    get getConfig(): DCarbonizeAppConfig;
    get getClient(): ClientAppConfig;
}

@Injectable({
    providedIn: 'root',
})
export class ConfigService implements IConfigService {
    private config: DCarbonizeAppConfig;

    constructor() {
        this.config = environment;
    }

    // getter: dcarb_config
    public get getConfig(): DCarbonizeAppConfig {
        return this.config;
    }

    public get getClient(): ClientAppConfig {
        return this.config.client;
    }
}
